<template>
    <div>
        <header class="page-header">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2>Отчеты</h2>
                    </div>
                </div>
                <form @submit.prevent="reportDownload">
                    <div class="row pb-3">

                        <div class="col-3">

                            <div class="trn-search-label">Фильтр</div>

                            <div class="row">

                                <div class="col-12">
                                    <div class="form-group">
                                        <app-datepicker-filter v-model="dateRange"></app-datepicker-filter>
                                    </div>
                                    <div class="form-group">
                                        <select v-model="formData.type" class="form-control">
                                            <option value="0" selected>Приём</option>
                                            <option value="1">Выплата</option>
                                        </select>
                                    </div>
                                    <button class="btn btn-primary" type="submit" v-if="dateRange">Скачать</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </header>
    </div>
</template>

<script>
    export default {
        name: "MerchantReports",
        data() {
            return {
                dateRange: null,
                formData: {
                    type: 0,
                    range_start: null,
                    range_end: null
                }
            }
        },
        methods: {
            reportDownload() {
                this.$store.commit('setLoading');
                this.formData.range_start = this.dateRange.start.replace(/'/g, "");
                this.formData.range_end = this.dateRange.end.replace(/'/g, "");
                axios.get('/admin/merchant-reports/export', {params: this.formData, responseType: 'blob'})
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Отчеты c ' + this.formData.range_start + ' по ' + this.formData.range_end + '.zip');
                        document.body.appendChild(link);
                        link.click();
                        this.$store.commit('unsetLoading');
                    })
                    .catch(function () {
                        alert('Отчеты не найдены');
                    });
            }
        }
    }
</script>

<style scoped>

</style>